var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio-container"},[_c('div',{staticClass:"radio",class:{
        checked: _vm.checked,
        disabled: _vm.disabled,
        error: _vm.error
      },attrs:{"id":`radio_${_vm.$attrs.id}`}},[_c('div',{staticClass:"radio-fill",class:{
          checked: _vm.checked
        }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }